<ng-container *ngIf="overviewready$(); else analizing">
    <ng-container *ngIf="myReportReadyOrAvailable$(); else beforeBuyBenchmark">
        <ng-container *ngTemplateOutlet="afterBuyBenchmark"></ng-container>
    </ng-container>
</ng-container>

<ng-template #analizing>
    <ng-container *ngIf="!missingFinancials$(); else missingFinancials">
        <div class="page-content fw bg-hero pb--48">
            <div class="intro pt--8  pb--8 pt--lg-64 pb--lg-64 container">
                <div class="row justify-content-center align-items-center row-analizing">
                    <h1 class="page-title-responsive animation-blink">
                        Stiamo analizzando i tuoi dati
                    </h1>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #missingFinancials>
    <company-data-error [errors]="companyAnalizingErrors$()"></company-data-error>
</ng-template>

<ng-template #beforeBuyBenchmark>
    <div class="page-content fw bg-hero pb--48">
        <div class="intro pt--8  pb--8 pt--lg-64 pb--lg-64 container">

            <div class="row">
                <!-- message comparison profist-loss-->
                <div class="col-12 col-md-7 col-lg-6 mt--8 mb--16 column align-items-start justify-content-center">
                    <h1 class="mat-headline-4 mb--16">{{ mycompany }}</h1>
                   
                   <!-- qui siamo nel caso di  profittabilita superiore al mercato -->
                    <ng-container *ngIf="profittabilitaAzienda > profittabilitaMercato; else noProfit">
                        <h1 class="page-title-responsive "
                            [innerHTML]="'page.dashboard.intro_question_ok' | translate:{value: 'La tua azienda'}"></h1>
                        <div class="h3 mt--16">Vuoi sapere come migliorare ancora?</div>
                    </ng-container>
                    <ng-template #noProfit>
                        <!-- qui siamo nel caso di profittabilita inferiore al mercato -->
                        <h1 class="page-title-responsive "
                            [innerHTML]="'page.dashboard.intro_question_nok' | translate: {value: 'Lo sai che la tua azienda'}"
                            >
                        </h1>
                        <div class="h3">
                            Hai {{ lossesOrProfits }} di <span class="text-highlight-bg">{{ ebitdaAbs | currency:'EUR':'symbol':'1.0-0' }}</span>, se fossi stato profittevole come i tuoi concorrenti avresti fatto utile per
                            <span class="text-highlight-bg">{{ potentialProfittabilityAzienda | currency:'EUR':'symbol':'1.0-0' }}</span>.
                        </div>
                        <div class="h3">Questa situazione ti è costata <span class="text-highlight-bg">{{utilePerso |
                                currency:'EUR':'symbol':'1.0-0' }}</span></div>
                    </ng-template>

                </div>

                <!-- graphic highlight -->
                <div class="col-12 col-md-5 col-lg-6 column m--0 justify-content-end">
                    <div class="promo-products text-center">
                        <div *ngIf="profitsValueDiff" class="profits-value-diff p--24 pb--0">
                            <!-- <span> {{ profitsValueDiff < 0 ? 'Mancato guadagno' : 'Guadagno' }}</span>  -->
                            <span translate> {{  profittabilitaAzienda < profittabilitaMercato ? 'Sei stato meno profittevole del ' : 'Sei più profittevole del' }} </span> {{ profitsValueDiff }}%
                        </div>
                        <div class="graph-overview"
                            *ngIf="graphicDataOverview && graphicDataOverview.graphic?.data.length>0">
                            <!-- <plotly-plot #plotbar *ngIf="graphicDataOverview" [updateOnDataChange]="true" [data]="graphicDataOverview.graphic.data" [layout]="graphicDataOverview.graphic.layout" [config]="graphicDataOverview.graphic.config"></plotly-plot> -->
                            <ngx-dashboard-card [cardContainerConfig]="graphicDataOverview.cardContainerConfig"
                                [graphic]="graphicDataOverview.graphic">
                            </ngx-dashboard-card>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mt--24 mb--24">
                        <!-- <ng-container *ngIf="downloadReportDirectly; else reportBuyFlow">
                            <ng-container *ngTemplateOutlet="reportDirectDownloadTemplate"></ng-container>
                        </ng-container>  -->
                        <ng-container [ngSwitch]="reportMode">
                            <ng-container *ngSwitchCase="'modal'"><ng-container *ngTemplateOutlet="reportDirectDownloadTemplate"></ng-container></ng-container>
                            <ng-container *ngSwitchCase="'page'"><ng-container *ngTemplateOutlet="reportBuyFlow"></ng-container></ng-container>
                            <ng-container *ngSwitchCase="'buttons'"><ng-container *ngTemplateOutlet="reportButtons"></ng-container></ng-container>
                            <ng-container *ngSwitchDefault><ng-container *ngTemplateOutlet="reportDirectDownloadTemplate"></ng-container></ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #reportDirectDownloadTemplate>
    <button (click)="getReportModal()" mat-flat-button color="primary" class="button-icon-suffix fs-18 p--24 lh-1">
        Vedi il tuo Benchmark personalizzato
        </button>
</ng-template>
<ng-template #reportBuyFlow>
    <ng-container *ngIf="myReportReadyOrAvailable$(); else callForReport">
        <button (click)="goToReport()" mat-flat-button color="primary" class="button-icon-suffix">
            <h5 class="m--0" translate>Vedi il tuo Benchmark personalizzato</h5><mat-icon
                class="mr--8">expand_more</mat-icon>
        </button>
    </ng-container>
</ng-template>
<ng-template #reportButtons>
    <ng-container >
        <div class="d-flex gap-16 flex-column flex-lg-row">
        <!-- <button *ngIf="showPlansButton" (click)="scrollToElement('planssection')" mat-flat-button color="primary" class="rounded p--24 p--lg-24 fs-20">{{ 'Piani di acquisto' | translate }}</button> -->
        <button (click)="downloadReport()" mat-stroked-button color="white" class="p--16 p--lg-24 fs-20 button-icon-suffix">
           <span [class.pulse]="downloading$()"> {{ downloading$() ? 'Download in corso...' : 'Scarica il tuo Benchmark Lite' | translate }}</span> <span class="di di-download"></span>
        </button>
        </div>
    </ng-container>
</ng-template>
<ng-template #callForReport>
    <!-- <app-component-identity-report [company]="companyEureso" [piva]="companyPiva" [buttononly]="true"></app-component-identity-report> -->
    <div class="h3 mb--48">Vuoi sapere perchè?</div>
    <div class="d-flex gap-16">
        <button (click)="scrollToElement('plans')" mat-flat-button color="primary"
            class="p--24 ">
            <span class="fs-18">Acquista subito un Benchmark</span>
        </button>
        <button (click)="scrollToElement('contactReport')" mat-stroked-button color="white"
            class="p--24 "><span class="fs-18">Contatta un consulente</span>
        </button>
    </div>
</ng-template>

<ng-template #afterBuyBenchmark>
    <div class="container-fluid py--24 py--lg-48 pb--lg-48">
        <div class=" bg-hero-alt  p--24 p--lg-48 container rounded">
            <div class="d-flex flex-column flex-lg-row gap-24">
                <div class="col-12 col-md-7 col-lg-6 column align-items-start justify-content-center"
                 isInVewport
                (isInViewport)="onViewportChange('titleintro',$event)"
                [threshold]="0.5">
                    <h3  [@fadeInRight] *ngIf="visibilityState['titleintro']" translate>
                        L'IA ha terminato l'analisi
                    </h3>
                    <div class="h5 mb--16 mb--lg-24" *ngIf="visibilityState['titleintro']" [@fadeInRight]="{value: '', params: {delay: '150ms'}}" translate>
                        Ecco il risultato dell'analisi di Delfi.ai.<br/>
                        Scarica il documento per visualizzare il risultato finale
                    </div>
                    <button (click)="goToReport(true)" mat-flat-button color="primary" class="button-icon-suffix border border-white" 
                    [@fadeInRight]="{value: '', params: {delay: '300ms'}}"
                    *ngIf="visibilityState['titleintro']" >
                        {{ downloading$() ? 'Download in corso...' : 'Scarica il tuo Benchmark' }}<span class="di di-download"></span>
                    </button>
                </div>
                <div class="col-12 col-md-5 col-lg-6 column m--0 justify-content-end">
                    <div class="promo-products-dark row"  [@fadeInLeft]
                        *ngIf="visibilityState['titleintro']">
                        <div *ngIf="profitsValueDiff" class="d-flex flex-column align-items-start justify-content-center col py--16">
                            <!-- <span> {{ profitsValueDiff < 0 ? 'Mancato guadagno' : 'Guadagno' }}</span>  -->
                            <div class="text-white " translate> {{  profittabilitaAzienda < profittabilitaMercato ? 'Potenziale incremento ' : 'Sei più profittevole del' }} </div>
                            <div class="text-white h2">{{ profitsValueDiff}}%</div>
                        </div>
                        <div class="graph-overview col-12 col-lg-8 p--0"
                            *ngIf="graphicDataOverview && graphicDataOverview.graphic?.data.length>0">
                            <!-- <plotly-plot #plotbar *ngIf="graphicDataOverview" [updateOnDataChange]="true" [data]="graphicDataOverview.graphic.data" [layout]="graphicDataOverview.graphic.layout" [config]="graphicDataOverview.graphic.config"></plotly-plot> -->
                            <ngx-dashboard-card [cardContainerConfig]="graphicDataOverview.cardContainerConfig"
                                [graphic]="graphicDataOverview.graphic">
                            </ngx-dashboard-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>